import {
  deletePortfolioAtPath,
  getPortfolioCountAtPath,
  loadPortfolioAtPath,
  loadPortfoliosAtPath,
  portfolioExistsAtPath,
  renamePortfolioAtPath,
  savePortfolioAtPath,
  updatePortfolioAtPath,
} from '../commonBlogUtils.js';


export const savePortfolio = async (userId, portfolioTitle, blogData) =>
  savePortfolioAtPath(['users', userId, 'draft-portfolios'], portfolioTitle, blogData, 'Portfolio');

export const loadPortfolio = async (userId, portfolioTitle) =>
  loadPortfolioAtPath(['users', userId, 'draft-portfolios'], portfolioTitle);

export const loadUserPortfolios = async (userId) =>
  loadPortfoliosAtPath(['users', userId, 'draft-portfolios']);

export const deletePortfolio = async (userId, portfolioTitle) =>
  deletePortfolioAtPath(['users', userId, 'draft-portfolios'], portfolioTitle, 'Portfolio');

export const updatePortfolio = async (userId, portfolioTitle, updateData) =>
  updatePortfolioAtPath(['users', userId, 'draft-portfolios'], portfolioTitle, updateData, 'Portfolio');

export const renamePortfolio = async (userId, oldTitle, newTitle) =>
  renamePortfolioAtPath(['users', userId, 'draft-portfolios'], oldTitle, newTitle, 'Portfolio');

export const portfolioExists = async (userId, portfolioTitle) =>
  portfolioExistsAtPath(['users', userId, 'draft-portfolios'], portfolioTitle);

export const getPortfolioCount = async (userId) =>
  getPortfolioCountAtPath(['users', userId, 'draft-portfolios']);





